function formatStore(store: any) {
  let userPermissions = store.userSettingsPermissions?.map(
    (item: any) => item?.PermissionId,
  );

  const user = {
    firstName: store.basicUserDetails.firstName,
    lastName: store.basicUserDetails.lastName,
    email: store.basicUserDetails.email,
    accountsInfo: store.accountsInfo
      ?.map((item: any) => item)
      .sort((a: any, b: any) => a - b),
    userSettingsPermissions: userPermissions?.sort((a: any, b: any) => a - b),
    customEmailNotificationSettings:
      store.defaultEmailNotification?.id === 8
        ? store.customEmailNotificationSettings
            ?.map((item: any) => ({
              NotifyTime: item?.NotifyTime,
              Id: item?.Id,
            }))
            .sort((a: any, b: any) => a.NotifyTime - b?.NotifyTime)
        : [],

    includeEmptyNotification: store.includeEmptyNotification,
    selectedOptions: store.selectedOptions,
    selectedChoiceOptions: store.selectedChoiceOptions,
    //person-alert-limiter
    optionsByAccount: store.optionsByAccount,
    accountQuestionSettings: store.accountQuestionSettings
      ?.map((item: any) => ({
        AccessTypeId: item?.AccessTypeId,
        HasLimitedAccessLookups: item?.HasLimitedAccessLookups,
        AccountId: item?.AccountId,
      }))
      .sort((a: any, b: any) => a.AccountId - b.AccountId),
    defaultEmailNotification: store.defaultEmailNotification,
  };
  return user;
}

//checking the data equal
function isUserDataEqual(initialData: any, currentData: any) {
  // filter out empty arrays
  const formatOptionsByAccount = (options: any) => {
    if (!options || typeof options !== 'object') return {};

    const formatted: any = {};
    for (const [key, value] of Object.entries(options)) {
      if (Array.isArray(value) && value.length > 0) {
        const valuesOnly = value
          .map(item => item?.value)
          .filter(v => v !== undefined && v !== null && v !== 0)
          .sort((a, b) => {
            return (a as number) - (b as number);
          });

        if (valuesOnly.length > 0) {
          formatted[key] = valuesOnly;
        }
      }
    }

    return formatted;
  };

  let tempInitialData = {
    ...initialData,
    customEmailNotificationSettings:
      initialData?.customEmailNotificationSettings?.map(
        (item: any) => item?.NotifyTime,
      ),
    //for person-alert-limiter
    optionsByAccount: formatOptionsByAccount(initialData?.optionsByAccount),
  };
  let tempCurrentData = {
    ...currentData,
    customEmailNotificationSettings:
      currentData?.customEmailNotificationSettings?.map(
        (item: any) => item?.NotifyTime,
      ),
    //for person-alert-limiter
    optionsByAccount: formatOptionsByAccount(currentData?.optionsByAccount),
  };
  console.log('tempInitialData', tempInitialData);
  console.log('tempCurrentData', tempCurrentData);
  if (JSON.stringify(tempInitialData) === JSON.stringify(tempCurrentData)) {
    return true;
  } else return false;
}
export { formatStore, isUserDataEqual };
